document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".tabs-container").forEach(container => {
    const buttons = container.querySelectorAll(".tab-button");
    const contents = container.querySelectorAll(".tab-content");

    if (buttons.length > 0) {
      buttons[0].classList.add("active");
      container.querySelector(`.tab-content[data-date="${buttons[0].dataset.date}"]`).style.display = "block";
    }

    buttons.forEach(button => {
      button.addEventListener("click", function() {
        buttons.forEach(btn => btn.classList.remove("active"));
        contents.forEach(content => content.style.display = "none");

        this.classList.add("active");
        container.querySelector(`.tab-content[data-date="${this.dataset.date}"]`).style.display = "block";
      });
    });
  });
});

// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".specialists-filter__li").forEach((li) => {
//     li.addEventListener("click", function () {
//       const checkbox = this.querySelector("input[type='checkbox']");
//       checkbox.checked = !checkbox.checked; // Перемикаємо чекбокс
//       document.querySelector(".specialists-filter__btn").click(); // Сабмітимо форму
//     });
//   });
// });


// document.addEventListener("DOMContentLoaded", () => {
//   const submitBtn = document.querySelector(".specialists-filter__btn");

//   // Сабмітимо після нативного перемикання
//   document.querySelectorAll(".specialists-filter__checkbox").forEach((cb) => {
//     cb.addEventListener("change", () => {
//       submitBtn.click();
//     });
//   });

//   // Клік по label теж перемикає нативно; просто сабмітимо
//   document.querySelectorAll(".specialists-filter__label").forEach((label) => {
//     label.addEventListener("click", () => {
//       // чекаємо нативне оновлення стану інпута
//       setTimeout(() => submitBtn.click(), 0);
//     });
//   });
// });


document.addEventListener('DOMContentLoaded', function () {
  const icon = document.querySelector('.specialists_icon');
  const filter = document.querySelector('.specialists-filter');
  const closeBtn = document.querySelector('.specialists-filter__close');

  if (icon && filter) {
    icon.addEventListener('click', function () {
      filter.classList.add('filter_active');
    });
  }

  if (closeBtn && filter) {
    closeBtn.addEventListener('click', function () {
      filter.classList.remove('filter_active');
    });
  }
});
